import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CandidateSector } from '../../models/candidateSector-model';

@Component({
  selector: 'app-sector-list',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sector-list.component.html',
  styleUrls: ['./sector-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectorListComponent {
  sectors = input.required<CandidateSector[]>();
  size = input<'default' | 'sm'>('default');

  constructor(private router: Router) {}

  navigateToSector(sector: CandidateSector) {
    const sectorSlug = sector.sector.toLowerCase().replace(' ', '~');
    this.router.navigate(['/sectors', sectorSlug]);
  }

  navigateToSectorList() {
    this.router.navigate(['/sectors']);
  }
}
